import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getYearlyBreedSalesInfo} from "../../../actions/breedSalesDashboard";
import { updateBreedType } from "../../../actions/addBreedType";
import {fetchBreedDashboardAvailableBreeds, fetchAvailableBreedCountWithMinimumBreed} from "../../../actions/breedSalesDashboard";
import { getCurrentPetShop } from "../../../actions/petShop";
import _ from "lodash";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import Select from "react-select";
import { Loader } from "../../../components/loader";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import moment from "moment";
import { align } from "@progress/kendo-drawing";
const { SearchBar } = Search;

const $ = window.$;

const BarChart = require("react-chartjs").Bar;
const HEADERCOLUMN = {
  totalCount : "totalContractCount",
  breeds : "Breeds",
  avg : "Avg",
}
const intialState = {
  salesSelectOptionYearly : [],
  breedSalesData: [],
  salesSelectedOptionYearly:"LAST12MONTH",
  salesSelectedOptionYearlyTimeFrameType : "LAST_6MONTH",
  loadingYearlyData : false,
  dashBoardAvailableBreeds: [],
  dashBoardBreedsCountData : [],
  tableHeadersalesInformationBreedSalesData : [
    {
      dataField: "Breeds",
      text: "Breeds",
      sort: true
    },
    {
      dataField: "Jan",
      text: "Jan",
      sort: true
    },
    {
      dataField: "Feb",
      text: "Feb",
      sort: true
    },
    {
      dataField: "Mar",
      text: "Mar",
      sort: true
    },
    {
      dataField: "Apr",
      text: "Apr",
      sort: true
    },
    {
      dataField: "May",
      text: "May",
      sort: true
    },
    {
      dataField: "Jun",
      text: "Jun",
      sort: true
    },
    {
      dataField: "Jul",
      text: "Jul",
      sort: true
    },
    {
      dataField: "Aug",
      text: "Aug",
      sort: true
    },
    {
      dataField: "Sep",
      text: "Sep",
      sort: true
    },
    {
      dataField: "Oct",
      text: "Oct",
      sort: true
    },
    {
      dataField: "Nov",
      text: "Nov",
      sort: true
    },
    {
      dataField: "Dec",
      text: "Dec",
      sort: true
    },
    {
      dataField: "totalContractCount",
      text: "Total Sales",
      sort: true
    },
  ],
  minimumQty : '',
  selectedBreed : null,
  loadingBreedMinimumQuantity : false,
  dashBoardBreedsCountDataPercentage : "",
  dashBoardBreedsCountavailableCountTotal : 0,
};

class BreedSalesDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = intialState;
  }
  tableHeaderDashBoardAvailableBreedSalesData = [
  {
    dataField: "breed_type",
    text: "Breeds",
    sort: true,  
  },
  {
    dataField: "minimum_quantity",
    text: "Minimum Quantity",
    sort: true,
    align : "right",
    formatter: (cell, row) => {
      return (     
      
          <a
            href='#'
            onClick={(e) => { this.openBreedQuantityChangeModal(e,row)}}
            style={{ cursor: "pointer", color : "#5867dd", fontWeight : "600", }}
            className="text-dark"
          >
          <div>
            <span>
              <i className="la la-edit"></i>
            </span>           
            <span>
              { cell ? cell : 0 }
            </span>
          </div>            
          </a>
        
      );
    },
    headerStyle: () => {
      return { width : "150px",textAlign: "center" };
    }
  },   
  ];
  tableHeaderDashBoardBreedCountData = [
  {
    dataField: "breed",
    text: "Breed",
    sort: true,  
  },
  {
    dataField: "availableCount",
    text: "Available Puppies",
    sort: true,
    align : "right",
    formatter: (cell, row) => {   
      return (        
        <span className="m-topbar__userpic">        
         <p className="text-dark"> <strong>{ cell ? cell : 0 }</strong></p>
        </span>
      );
    },
    headerStyle: () => {
      return { width : "150px", textAlign: "center", };
    },
    style: (cell, row, rowIndex, colIndex) => {     
      let percentage = row.minimumCount > 0 ? (row.availableCount/row.minimumCount)*100 : null;
      return { backgroundColor: percentage == 0 ? "#dc3545" : 1 <= percentage && percentage < 100 ? '#e83e8c' : 100 <= percentage &&  percentage <=  110 ? '#ffc107' : percentage > 110 ? '#28a745' : '' };
    },
  },  
  ];

  changeSalesOptionYearly = (selected) => {
    if(selected){     
        this.setState({ salesSelectedOptionYearly : selected.value, salesSelectedOptionYearlyTimeFrameType : selected.type, loadingYearlyData : true  });
        this.props.getYearlyBreedSalesInfo( selected.type ,selected.startDate); 
    }  
  }

  loadSalesSelectionDataYearly = () => {
    let yearlySelectionData = []; 
    const lastTwelveMonthStartMonth = moment().subtract(11,"month").format("YYYY-MM");
    yearlySelectionData.push( 
        {
        label: `LAST 12 MONTH`,
        value: `LAST12MONTH`,
        type : 'LAST_12MONTH',      
        startDate: `${lastTwelveMonthStartMonth}-01`,
        },
    );
    for (let i = 0; i < 5; i++) { 
      let year = moment().subtract(i, "years").format("YYYY");
      yearlySelectionData.push({
        id : i+1,
        label: `${year}`,
        value: `${year}`,
        type : 'FULL_YEAR',      
        startDate: `${year}-01-01`,
      });
    }

    this.setState({
      salesSelectOptionYearly: yearlySelectionData, loadingYearlyData : true
    });  
    let defaultStartDate = `${lastTwelveMonthStartMonth}-01`; 
    this.props.getYearlyBreedSalesInfo( 'LAST_12MONTH', defaultStartDate); 
  };

  openBreedQuantityChangeModal = (e,row) => {
    e.preventDefault();
    let breedData = {
      id : row.id,   
    };
    $("#edit_breed_minimum_quantity_modal").modal("show");
    const breedAttributes = row.BreedAttributeLists;
    let attributesList = [];
    for(let attribute of breedAttributes){
     let data = {
      label : attribute.BreedAttribute.name,
      value : attribute.BreedAttribute.id
     };
     attributesList.push(data);
    }
    breedData.breedAttributes = attributesList;
    this.setState({ selectedBreed : breedData, minimumQty : row.minimum_quantity  });
  }

  editMinimumQuantity = (e) => {
    e.preventDefault();
    let selectedBreedData = this.state.selectedBreed;
    if(selectedBreedData){
    selectedBreedData.minimum_quantity = this.state.minimumQty;
    this.setState({ loadingBreedMinimumQuantity : true });
    this.props.updateBreedType(selectedBreedData);
    }else{
      NotificationManager.warning("Breed data not found");
    }
  }

  changeQuantity = event => {
    let value = event.target && event.target.value ? event.target.value : 0;
    this.setState({ minimumQty: event.target.value });
  };

  componentDidMount() {
    this.props.fetchBreedDashboardAvailableBreeds();
    this.props.fetchAvailableBreedCountWithMinimumBreed();
    this.loadSalesSelectionDataYearly();
  }

  componentWillReceiveProps = (nextProps) => {  

    if(this.props.contractsYearlyBreedSalesData !== nextProps.contractsYearlyBreedSalesData){ 
      const breedSalesData = nextProps.contractsYearlyBreedSalesData.contractCountViaBreed;
      const headerFirstObjbreedSalesData = breedSalesData && breedSalesData.length > 0 ? breedSalesData[0] :  [];
      const defaultHeadersalesInformationBreedSalesData = this.state.tableHeadersalesInformationBreedSalesData;
      let breedSalesDataTempHeader = [];  
      for(let itemObj in headerFirstObjbreedSalesData){   
        let headerobj = {};
        if(itemObj == HEADERCOLUMN.totalCount ){
          headerobj = {
            dataField : itemObj,
            text : 'Total Sales',                
            sort : true,
            align : 'right',
            headerStyle: () => {
              return {  textAlign: "center" };
            }          
          }
        }else if(itemObj == HEADERCOLUMN.breeds ){
          headerobj = {
            dataField : itemObj,
            text : itemObj,
            sort : true,                        
          }
        }else if(itemObj == HEADERCOLUMN.avg ){
          headerobj = {
            dataField : itemObj,
            text : 'Monthly Avg',
            align : 'right',
            sort : true,  
            headerStyle: () => {
              return {  textAlign: "center" };
            }                        
          }
        }else{
          headerobj = {
            dataField : itemObj,
            text : itemObj,
            sort : true,   
            align : 'right',
            headerStyle: () => {
              return {  textAlign: "center" };
            }       
          }
        } 
        breedSalesDataTempHeader.push(headerobj)  
      }   
      this.setState({
        breedSalesData : breedSalesData,
        tableHeadersalesInformationBreedSalesData : breedSalesDataTempHeader && breedSalesDataTempHeader.length > 0 ? breedSalesDataTempHeader :defaultHeadersalesInformationBreedSalesData, 
        loadingYearlyData : false,
      });
    }  
    
    if ( nextProps.contractsYearlyBreedSalesDataError &&
      this.props.contractsYearlyBreedSalesDataError !== nextProps.contractsYearlyBreedSalesDataError ) {
      NotificationManager.error("An error occurred while loading the Breed sales information");
    } 
       
    if(nextProps.dashBoardAvailableBreeds && this.props.dashBoardAvailableBreeds !== nextProps.dashBoardAvailableBreeds ){ 
      this.setState({ dashBoardAvailableBreeds : nextProps.dashBoardAvailableBreeds.breedList, dashBoardAvailableBreedsTotalCount : nextProps.dashBoardAvailableBreeds.totalMinimumBreedCount  });
    }

    if(this.props.dashBoardBreedsCount !== nextProps.dashBoardBreedsCount){  
     let percentage = nextProps.dashBoardBreedsCount.minimumCountTotal ? (nextProps.dashBoardBreedsCount.availableCountTotal / nextProps.dashBoardBreedsCount.minimumCountTotal)*100 : null;
      this.setState({ dashBoardBreedsCountData : nextProps.dashBoardBreedsCount.breedList, 
        dashBoardBreedsCountDataPercentage : percentage,
        dashBoardBreedsCountavailableCountTotal : nextProps.dashBoardBreedsCount.availableCountTotal,
       });
    }

    if (nextProps.breedTypeUpdated && this.props.breedTypeUpdated  !== nextProps.breedTypeUpdated) { 
      this.props.fetchAvailableBreedCountWithMinimumBreed();
      this.props.fetchBreedDashboardAvailableBreeds();
      this.setState({ loadingBreedMinimumQuantity : false });
      NotificationManager.success("Breed Type Updated");
      $("#edit_breed_minimum_quantity_modal").modal("hide");
    }

    if ( nextProps.dashBoardAvailableBreedsError && this.props.dashBoardAvailableBreedsError !== nextProps.dashBoardAvailableBreedsError ) {
      NotificationManager.error("An error occurred while loading the Breed sales information");
    } 
    
    if ( nextProps.dashBoardBreedsCountError && this.props.dashBoardBreedsCountError !== nextProps.dashBoardBreedsCountError ) {
      NotificationManager.error("An error occurred while loading the Breed sales information");
    } 

  };

  render() {
    const { 
      salesSelectOptionYearly,
      salesSelectedOptionYearly,
      loadingYearlyData,
      tableHeadersalesInformationBreedSalesData,
      breedSalesData,
      dashBoardAvailableBreeds,  
      dashBoardBreedsCountData,   
      minimumQty,
      loadingBreedMinimumQuantity,
      dashBoardBreedsCountDataPercentage,
      dashBoardBreedsCountavailableCountTotal,
    } = this.state;

    const { petShop } = this.props;
    return (
      <div
        className="m-grid m-grid--hor m-grid--root m-page"
        style={{ minHeight: "100vh" }}      >
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper container"> 
       
              <div className="row">
                 <div className="col-xl-6 col-md-12">							
                    <div className="m-portlet m-portlet--full-height" style={{ maxHeight: "360px", overflow: 'auto'}}>
                      <div className="m-portlet__head">                      
                        <div className="m-portlet__head-caption">                  
                          <table className="table m-table">												
                          <tbody>
                            <tr className="m-table__row--active">                            
                              <td bgcolor="#dc3545" style={{ width :"85px"}}><strong>{'Equal 0'}</strong></td>
                              <td bgcolor="#e83e8c"> <strong>{'Less than 100%'}</strong></td>
                              <td bgcolor="#ffc107"><strong>{'Between 100% and 110%'}</strong></td>
                              <td bgcolor="#28a745"><strong>{'Above 110%'}</strong></td>
                            </tr>      
                          </tbody>
                      </table>
                       </div>              
                      </div> 
                      <div className="m-portlet__body">        
                        <div className="row">                    
                          <div className="col-xl-12">
                            <ToolkitProvider  
                             keyField="Category"                                      
                             data= {dashBoardBreedsCountData}
                             columns={this.tableHeaderDashBoardBreedCountData}
                             search
                             hover={true}
                             filter={filterFactory()}
                            >
                            {props => (
                            <div>    
                             <div className="px-0 mb-4 search-bar">
                              <div className="col-lg-3 px-0 inner-addon right-addon">
                                <i className="fas fa-search"></i>
                                <SearchBar {...props.searchProps} />
                              </div>
                             </div>   
                           <table className="table m-table">												
                            <tbody>
                              <tr className="m-table__row--active">                            
                                <td><strong>No of available puppies for sale</strong></td>
                                <td bgcolor= {dashBoardBreedsCountDataPercentage == 0 ? "#dc3545" : 1 <= dashBoardBreedsCountDataPercentage && dashBoardBreedsCountDataPercentage < 100 ? '#e83e8c' : 100 <= dashBoardBreedsCountDataPercentage &&  dashBoardBreedsCountDataPercentage <=  110 ? '#ffc107' : dashBoardBreedsCountDataPercentage > 110 ? '#28a745' : ''} style={{ width : "150px"}} align ="right"> <p1 className="text-dark"><strong>{dashBoardBreedsCountavailableCountTotal}</strong></p1></td>                       
                              </tr>      
                            </tbody>
                            </table>                                                    
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}   
                              pagination={paginationFactory()}                                                                               
                            />  
                            </div>
                            )}
                           </ToolkitProvider> 
                          </div>                                        
                         </div>         
                      </div>
                    </div>
                 </div>
                 <div className="col-xl-6 col-md-12">							
                    <div className="m-portlet m-portlet--full-height" style={{ maxHeight: "360px",  overflow: 'auto'}}>
                      <div className="m-portlet__head">                      
                        <div className="m-portlet__head-caption">                  
                       </div>              
                      </div>
                      <div className="m-portlet__body">     
                      <div className="row"> 
                       { dashBoardAvailableBreeds && dashBoardAvailableBreeds.length == 0 && 
                       <div className="col-12">
                        <span> <h5>Minimum quantities not configured</h5></span>     
                       </div>
                       } 
                       { dashBoardAvailableBreeds && dashBoardAvailableBreeds.length > 0 &&                  
                        <div className="col-xl-12">
                          <ToolkitProvider  
                           keyField="Category"                                      
                           data= {dashBoardAvailableBreeds}
                           columns={this.tableHeaderDashBoardAvailableBreedSalesData}
                           search
                           hover={true}
                           filter={filterFactory()}
                          >
                          {props => (
                          <div>     
                            <div className="px-0 mb-4 search-bar">
                              <div className="col-lg-3 px-0 inner-addon right-addon">
                                <i className="fas fa-search"></i>
                                <SearchBar {...props.searchProps} />
                              </div>
                            </div>      
                            <table className="table m-table">												
                          <tbody>
                            <tr className="m-table__row--active">                            
                              <td><strong>Minimum</strong></td>
                              <td style={{ width : "150px", textAlign : "right"}}> <strong>{this.state.dashBoardAvailableBreedsTotalCount}</strong></td>                       
                            </tr>      
                          </tbody>
                         </table>                                                    
                          <BootstrapTable
                            classes="petTable"
                            {...props.baseProps}   
                            pagination={paginationFactory()}                                                                               
                          />  
                          </div>
                          )}
                          </ToolkitProvider>
                        </div>                    
                       }                                   
                       </div>        
                      </div>
                    </div>
                 </div>
              </div> 
              <div className="row">
                 <div className="col-xl-12 col-md-12">							
                    <div className="m-portlet m-portlet--full-height" style={{ overflow: 'auto'}}>
                      <div className="m-portlet__head">                      
                        <div className="m-portlet__head-caption">
                          <div className="m-portlet__head-title">
                            <h3 className="m-portlet__head-text">
                              Sales Information
                            </h3>
                          </div>                          
                        </div>                                    
                        <div style={{width: "170px", margin: "0", marginTop: "10px"}}>                                                                                                                    
                          <Select
                            options={salesSelectOptionYearly}                                             
                            value ={salesSelectedOptionYearly}                                      
                            name="selectOption"
                            onChange={this.changeSalesOptionYearly}
                            placeholder="Select Sales Filter"                                  
                          />                                                                 
                        </div>                                 
                      </div>
                      <div className="m-portlet__body">        
                          <div className="row">
                          { !loadingYearlyData ?
                            <div className="col-xl-12">                          
                              <ToolkitProvider  
                                keyField="Category"                                      
                                data= {breedSalesData}
                                columns={tableHeadersalesInformationBreedSalesData}
                                search
                                hover={true}
                                filter={filterFactory()}
                              >
                            {props => (
                            <div>                                                              
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}   
                              pagination={paginationFactory()}                                                                               
                            />  
                            </div>
                             )}
                              </ToolkitProvider>
                            </div>:
                            <div className={"loader-center"}>
                              <Loader
                                type="line-scale"
                                active={true}
                                size={25}
                              />
                           </div>
                          }                               
                          </div>                                   
                   
                      </div>
                    </div>
                  </div>
              </div>         
            </div>
          </div>
        </div>
        {/* start Breed minimum quantity edit */}
        <div
          className="modal fade"
          id="edit_breed_minimum_quantity_modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="SectionSelectModalLabel"
          aria-hidden="true"             
        >
         <div className="modal-dialog modal-md" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Edit Minimum Quantity
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <>
                 <div className="m-form form-group m-form__group row mb-0">
                  <label className="col-lg-4 pt-3">
                    Quantity:
                  </label>
                  <div className="col-lg-8 input-group m-input-group pl-0">              
                    <input
                      type="number"           
                      step={50}                            
                      value={ minimumQty > 0 ? minimumQty : ""}
                      onChange={this.changeQuantity}
                      className="form-control m-input"                                      
                      aria-describedby="basic-addon1"
                    />   
                  </div>                                            
                 </div>                            	                   
	              </>               
              </div>
              <div className="modal-footer">
              { !loadingBreedMinimumQuantity ?
                <div>
                  <button
                    type="button"
                    className="btn btn-secondary m-btn--pill mx-2"
                    data-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={(e) => this.editMinimumQuantity(e)}
                    className="btn btn-primary m-btn--pill"
                  >
                    Submit
                  </button>
                </div>:
                <div className="center-row">
                  <Loader size={50} />
                </div>
              }
              </div>
            </div>
         </div>
        </div>
           
      {/* end price edit */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.cognito.user,
  contractsYearlyBreedSalesData: state.breedSalesDashBoardReducer.contractsYearlyBreedSalesData,
  contractsYearlyBreedSalesDataError: state.breedSalesDashBoardReducer.contractsYearlyBreedSalesDataError,
  dashBoardAvailableBreeds: state.breedSalesDashBoardReducer.dashBoardAvailableBreeds,
  dashBoardAvailableBreedsError: state.breedSalesDashBoardReducer.dashBoardAvailableBreedsError,
  dashBoardBreedsCount: state.breedSalesDashBoardReducer.dashBoardBreedsCount,
  dashBoardBreedsCountError: state.breedSalesDashBoardReducer.dashBoardBreedsCountError,
  petShop: state.petShopReducer.currentPetshop,
  breedTypeUpdated : state.addBreedTypeReducer.updateBreedType
});
const mapDispatchToProps = (dispatch) => ({
  getCurrentPetShop: (t) => {
    dispatch(getCurrentPetShop(t));
  },
  getYearlyBreedSalesInfo: (type,start_date) => {
    dispatch(getYearlyBreedSalesInfo(type,start_date));
  },
  fetchBreedDashboardAvailableBreeds: () => {
    dispatch(fetchBreedDashboardAvailableBreeds());
  },
  fetchAvailableBreedCountWithMinimumBreed: () => {
    dispatch(fetchAvailableBreedCountWithMinimumBreed());
  },
  updateBreedType: (breed) => {
    dispatch(updateBreedType(breed));
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BreedSalesDashboard),
);
